// extracted by mini-css-extract-plugin
export default {"products":"Hy-z","card":"Iy-z","oosMessaging":"Jy-z"};